import React from 'react';

const CALENDLY_URL = 'https://calendly.com/swallacemeeting/bizdevconsult';

const steps = [
  {
    number: '1',
    title: 'Reframing',
    description:
      'Know where you are to know where you\'re going. We evaluate your current model and reframe it so you make more money, in less time, for longer.',
    outcome: 'From time-for-money to leveraged revenue',
  },
  {
    number: '2',
    title: 'Sourcing',
    description:
      'Perfect your positioning. We reverse engineer what your prospects really want to build messaging that makes them say "I need that."',
    outcome: 'Stand out with compelling positioning',
  },
  {
    number: '3',
    title: 'Implementing',
    description:
      'Get out of urgency mode. We set up CRM, collateral, pipelines, and everything you need to stop scrambling and start scaling.',
    outcome: 'From spread thin to exciting and growing',
  },
  {
    number: '4',
    title: 'NIMBLE Pipeline',
    description:
      'Your best clients come from people you already know. We build a curated group of relationships managed through a strategic, systematic process.',
    outcome: 'A flywheel of unlimited opportunities',
  },
  {
    number: '5',
    title: 'Control',
    description:
      'Add revenue without adding time. Implement ascension strategies that multiply your income without multiplying your hours.',
    outcome: 'Choose your clients and control your growth',
  },
];

const NimbleSystem = () => {
  return (
    <section id="nimble" data-testid="nimble-section" className="section" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-lg mb-4">The NIMBLE Pipeline Development System</h2>
          <p className="text-base md:text-lg mb-6" style={{ color: 'var(--text-secondary)', maxWidth: '640px', margin: '0 auto' }}>
            A referral generation system so you'll never have to buy leads, cold call, or network aimlessly again.
          </p>
          <span
            className="inline-block text-sm font-semibold px-5 py-2 rounded-full"
            style={{ backgroundColor: 'var(--bg-accent)', color: 'var(--brand-primary)' }}
          >
            Eliminate ad spend and cold outreach forever
          </span>
        </div>

        <div className="max-w-3xl mx-auto space-y-8 mb-16">
          {steps.map((step) => (
            <div
              key={step.number}
              className="flex items-start gap-6 p-6 rounded-2xl border border-gray-100 transition-all duration-200 hover:shadow-md"
              data-testid={`nimble-step-${step.number}`}
            >
              <div
                className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-lg font-bold text-white"
                style={{ backgroundColor: 'var(--brand-primary)' }}
              >
                {step.number}
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
                  {step.title}
                </h3>
                <p className="text-sm mb-3" style={{ color: 'var(--text-secondary)' }}>
                  {step.description}
                </p>
                <span
                  className="inline-block text-xs font-semibold px-3 py-1 rounded-full"
                  style={{ backgroundColor: '#ecfdf5', color: 'var(--brand-success)' }}
                >
                  {step.outcome}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center p-10 rounded-2xl" style={{ backgroundColor: 'var(--bg-secondary)' }}>
          <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
            The End Result
          </h3>
          <p className="text-base mb-4" style={{ color: 'var(--text-secondary)', maxWidth: '560px', margin: '0 auto 1rem' }}>
            NIMBLE lets you dominate your growth. No more ad spend. No more cold outreach. No more buying leads. Just a system that fills your pipeline on autopilot.
          </p>
          <div className="p-4 rounded-xl mb-6 inline-block" style={{ backgroundColor: 'var(--bg-accent)' }}>
            <p className="text-sm" style={{ color: 'var(--text-primary)' }}>
              <strong>Best for:</strong> B2B companies with 5–50 employees.
              <br />
              <span style={{ color: 'var(--text-secondary)' }}>
                Solopreneur? <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="underline font-semibold" style={{ color: 'var(--brand-primary)' }}>Book a call</a> to find the right fit for you.
              </span>
            </p>
          </div>
          <div>
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary px-8 py-4"
              data-testid="nimble-cta"
              aria-label="Discover NIMBLE for your business"
            >
              Discover NIMBLE for Your Business
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NimbleSystem;
